<script setup>
/* eslint-disable */
import EsportRegions from './EsportRegions.vue';
import EsportTopCompetitions from './EsportTopCompetitions.vue';
import LeftSidebarFavourites from './LeftSidebarFavourites.vue';
import { useFavouritesStore } from '@/stores/favourites';

const favouritesStore = useFavouritesStore();

</script>
<template>
	<div v-if="$route.name == 'esports-all-upcoming'" class="accordion-outer">
		<LeftSidebarFavourites/>
	</div>

	<div v-if="$route.name != 'esports-all-upcoming'" class="accordion-outer">
		<LeftSidebarFavourites v-if="Object.keys(favouritesStore.esportsLeftSidebarFavourites).length > 0"/>
		<EsportTopCompetitions/>
		<!-- Regions -->
		<EsportRegions/>
	</div>
</template>